import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { AppBar, Alert, Box, Button, ButtonBase, Stack, Toolbar, Typography, IconButton } from '@mui/material';
// import { loadCaptchaEnginge } from 'react-simple-captcha';
// hooks
import useOffSetTop from '../../../hooks/useOffSetTop';
import useResponsive from '../../../hooks/useResponsive';
// utils
import cssStyles from '../../../utils/cssStyles';
// config
import { HEADER } from '../../../config';
// components
import Logo from '../../../components/Logo';
import Iconify from '../../../components/Iconify';
import LoginSignupDialog from './visitor/LoginSignupDialog';
import ForgotPasswordDialog from './forgotpassword/ForgotPasswordDialog';
import ResetPasswordDialog from './forgotpassword/ResetPasswordDialog';
import { useDispatch, useSelector } from '../../../redux/store';
import { openLoginSignup } from '../../../redux/slices/authPages';

import NotificationPopover from './NotificationPopover';
import AccountPopover from './AccountPopover';
import useLocales from '../../../hooks/useLocales';
import { fNumber } from '../../../utils/formatNumber';
import palette from '../../../theme/palette';
import { ThemeButton } from '../../GlobalStyles';
import useAuth from '../../../hooks/useAuth';
import LanguagePopover from './LanguagePopover';
import SubHeaderNav from '../../../views/game/SubHeaderNav';
import Image from '../../../components/Image';
import { IconButtonAnimate } from '../../../components/animate';
import { setIsDownloadHeaderOpen } from '../../../redux/slices/settings';
import { openTransactionsDialog } from '../../../redux/slices/transactionsDialog';

// ----------------------------------------------------------------------

const RootStyle = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'isCollapse' && prop !== 'isOffset' && prop !== 'verticalLayout',
})(({ theme, showDownloadApp, isDesktop }) => ({
  ...cssStyles(theme).bgBlur(),
  // boxShadow: '0px 1px 5px 5px rgb(0, 0, 0, 0.2)',
  background: palette.header.bgColor,
  height: HEADER.MOBILE_HEIGHT,
  zIndex: theme.zIndex.appBar + 1,
  top: showDownloadApp && !isDesktop ? '15vw' : 0,
  maxWidth: '100%',
  transition: theme.transitions.create(['width', 'height'], {
    duration: theme.transitions.duration.shorter,
  }),

  // [theme.breakpoints.up('lg')]: {
  //   height: HEADER.DASHBOARD_DESKTOP_HEIGHT,
  //   width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH + 1}px)`,
  //   ...(isCollapse && {
  //     width: `calc(100% - ${NAVBAR.DASHBOARD_COLLAPSE_WIDTH}px)`,
  //   }),
  //   ...(isOffset && {
  //     height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
  //   }),
  //   ...(verticalLayout && {
  //     width: '100%',
  //     height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
  //     backgroundColor: theme.palette.background.default,
  //   }),
  // },
}));

const DownloadAppAlert = styled(Alert)(({ theme }) => ({
  backgroundImage: `url(${require('../../../assets/download/bg_top.jpg')})`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  fontSize: 9,
  fontWeight: 400,
  display: 'flex',
  alignItems: 'center',
  borderRadius: 0,
  padding: '0px 16px',
  position: 'fixed',
  top: 0,
  zIndex: 1,
  width: '100%',
  height: '15vw',
}));

const DownloadBtn = styled(ButtonBase)(({ theme }) => ({
  background: 'linear-gradient(165deg, rgb(0, 199, 199) -17.16%, rgb(19, 38, 216) 91.36%)',
  boxShadow: 'rgba(0, 0, 0, 0.25) 0px 4px 4px 0px',
  padding: '.5vw 4vw',
  borderRadius: '1vw',
  maxWidth: 'fit-content',
  flex: 1,
}));

const DepositBtn = styled(Stack)(({ theme }) => ({
  background: 'rgb(255, 255, 255, .1)',
  padding: '.125rem',
  paddingRight: '.5rem',
  borderRadius: '.25rem',
  alignItems: 'center',
  height: 35,
  boxShadow: '1px 1px 4px 4px rgb(0, 0, 0, .1)',
  cursor: 'pointer',
}));

const DepositBtnTxt = styled(Typography)(({ theme }) => ({
  fontSize: '.75rem',
  lineHeight: '1rem',
  color: '#fff',
  fontWeight: 500,
}));

// ----------------------------------------------------------------------

DashboardHeader.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onOpenSidebar: PropTypes.func,
  isCollapse: PropTypes.bool,
  verticalLayout: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
  onToggleCollapse: PropTypes.func,
};

export default function DashboardHeader({
  isOpenSidebar = false,
  onOpenSidebar,
  isCollapse = false,
  verticalLayout = false,
  // onCloseSidebar,
  onToggleCollapse,
  // showDownloadApp,
  // setShowDownloadApp,
}) {
  const isOffset = useOffSetTop(HEADER.DASHBOARD_DESKTOP_HEIGHT) && !verticalLayout;

  const { isAuthenticated } = useAuth();

  const isDesktop = useResponsive('up', 'sm');

  const { translate } = useLocales();

  const dispatch = useDispatch();

  const { memberBalance, isDownloadHeaderOpen } = useSelector((x) => ({ ...x.lookup, ...x.authPages, ...x.settings }));

  const [openForgotPasswordDialog, setOpenForgotPasswordDialog] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('referralCode') && !localStorage.getItem('accessToken')) {
      setTimeout(() => {
        dispatch(openLoginSignup({ open: true, isLogin: false }));
      }, 1000);
    }
    // Check if got resetpassword token
    // if (sessionStorage.getItem('resetToken')) {
    //   setOpenResetPasswordDialog(true);
    // }
  }, []);

  useEffect(() => {
    if (localStorage.getItem('accessToken')) {
      // getProfile();
    } else {
      console.log('loggedoff');
    }
  }, [localStorage.getItem('accessToken')]);

  // useEffect(() => {
  //   if (isOpenLoginSignupDialog.open)
  //     setTimeout(() => {
  //       loadCaptchaEnginge(4);
  //     }, 1000);
  // }, [isOpenLoginSignupDialog]);

  return (
    <>
      {isDownloadHeaderOpen && !isDesktop && (
        <DownloadAppAlert
          icon={
            <Iconify
              icon={'ic:round-close'}
              sx={{ color: '#fff', height: '5vw', width: '5vw' }}
              onClick={() => dispatch(setIsDownloadHeaderOpen(false))}
            />
          }
          variant="filled"
          severity="info"
          sx={{
            '.MuiAlert-message': {
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            },
          }}
        >
          <Stack
            direction={'row'}
            onClick={() => {
              navigate('/download');
              window.location.reload();
            }}
            spacing={'3vw'}
            sx={{ width: '100%', alignItems: 'center' }}
          >
            <Image
              src={require('../../../assets/brand-logo.png')}
              sx={{
                width: '15vw',
                maxWidth: '15vw',
                flex: '1',
                img: {
                  objectFit: 'contain',
                },
              }}
            />

            <Stack sx={{ flex: 1 }}>
              <Typography sx={{ color: '#fff', fontWeight: 500, fontSize: '3.5vw' }}>
                {translate('download_app_now')}
              </Typography>
              <Typography sx={{ color: '#fff', fontWeight: 400, fontSize: '2.5vw' }}>
                {translate('enhance_playing')}
              </Typography>
            </Stack>
            <DownloadBtn>
              <Typography sx={{ fontWeight: 600, fontSize: '3vw', color: '#fff' }}>{translate('download')}</Typography>
            </DownloadBtn>
          </Stack>
        </DownloadAppAlert>
      )}

      <RootStyle
        isCollapse={isCollapse}
        isOffset={isOffset}
        verticalLayout={verticalLayout}
        showDownloadApp={isDownloadHeaderOpen}
        isDesktop={isDesktop}
      >
        <Toolbar
          sx={{
            minHeight: '100% !important',
            pl: { lg: 1 },
            pr: { lg: 2 },
          }}
        >
          {/* {isDesktop && (
            <>
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Logo />
              </Box>
              <Box sx={{ float: 'right' }}>
                <LanguagePopover />
              </Box>
            </>
          )} */}

          {/* {isDesktop && ( */}
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              alignItems: 'center',
              justifyContent: isDesktop ? 'normal' : 'space-between',
              flexGrow: 1,
            }}
          >
            {!isDesktop && (
              <IconButtonAnimate
                onClick={() => onOpenSidebar()}
                sx={{
                  borderRadius: 1,
                  background: 'linear-gradient(138.07deg, #FE0404 11.32%, #390000 96.42%)',
                  boxShadow: '0px 0px 5px 0px #FFACAC',
                  p: 0.5,
                }}
              >
                <Iconify icon="ic:round-menu" />
              </IconButtonAnimate>
            )}

            <Logo />
            {/* <LanguagePopover /> */}

            {/* <IconButton>
              <Iconify icon={'ic:round-search'} />
            </IconButton> */}

            {isDesktop && (
              // <Box
              //   sx={{
              //     background: 'linear-gradient(rgb(192, 103, 39), rgb(221, 169, 84), rgb(28, 42, 179))',
              //     padding: '1px',
              //     borderRadius: 1,
              //   }}
              // >
              <>
                <Box sx={{ float: 'right' }}>
                  <LanguagePopover />
                </Box>
                <Button
                  sx={{
                    background: 'linear-gradient(to bottom, #ED4A33, #FB0500)',
                    py: 0.5,
                  }}
                  onClick={() => navigate('/promotion')}
                >
                  <Image
                    src={require('../../../assets/home/promotion.webp')}
                    sx={{ width: '2rem', height: '2rem', ml: -1 }}
                  />
                  <Typography sx={{ color: '#fff', fontWeight: 500 }}>{translate('promotion')}</Typography>
                </Button>
              </>
              // </Box>
            )}
            {/* )} */}

            {/* {isDesktop && (
          <Stack direction="row" alignItems={'center'}>
            <Box
              onClick={() => onToggleCollapse()}
              sx={{
                background: palette.header.menuBg,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '4px',
                p: '5px',
                mr: 2,
                cursor: 'pointer',
              }}
            >
              <Iconify icon={'ion:menu'} color={palette.header.menu} width="25px" height="25px" />
            </Box>
            <Image
              className="header-logo"
              onClick={() => navigate('/home')}
              src={require('../../../assets/brand-logo.png')}
              alt="App Logo"
              sx={{
                height: '50px',
                width: 'auto',
                ml: 1,
                cursor: 'pointer',
                '& img': {
                  width: 'auto !important',
                },
              }}
            />
          </Stack>
        )} */}

            {isDesktop && <Box sx={{ flexGrow: 1 }} />}
            <Box sx={{ position: 'relative', minHeight: '30px', minWidth: { xs: '28px', sm: 'unset' } }}>
              <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                sx={{
                  position: { xs: 'absolute', sm: 'relative' },
                  top: 0,
                  right: 0,
                }}
              >
                {!isAuthenticated && isDesktop ? (
                  <>
                    <ThemeButton
                      onClick={() => dispatch(openLoginSignup({ open: true, isLogin: true }))}
                      sx={{ color: palette.dark.common.white, px: 2 }}
                    >
                      {translate('login')}
                    </ThemeButton>
                    <ThemeButton
                      sx={{ background: 'linear-gradient(rgb(0, 59, 169), rgb(0, 77, 219))', px: 2 }}
                      onClick={() => dispatch(openLoginSignup({ open: true, isLogin: false }))}
                    >
                      {translate('sign_up')}
                    </ThemeButton>
                  </>
                ) : (
                  ''
                )}

                {isAuthenticated ? (
                  <Stack direction={'row'} spacing={0.3} sx={{ alignItems: 'center' }}>
                    {!isDesktop && (
                      <DepositBtn
                        onClick={() => dispatch(openTransactionsDialog({ open: true, isDeposit: true }))}
                        direction="row"
                        spacing={'.125rem'}
                        sx={{ pl: '.5rem' }}
                      >
                        <Image
                          src={require('../../../assets/mobile-menu/deposit.png')}
                          sx={{
                            width: '20px',
                            height: '20px',
                            img: {
                              objectFit: 'contain',
                            },
                          }}
                        />
                        <DepositBtnTxt>{`${
                          memberBalance?.displayBalance ? fNumber(memberBalance?.displayBalance) : '0'
                        }`}</DepositBtnTxt>
                      </DepositBtn>
                    )}
                    {isDesktop && (
                      <Box
                        sx={{
                          display: 'flex',
                          borderRadius: '6px',
                          background: palette.header.balance_button.bg,
                        }}
                        onClick={() => dispatch(openTransactionsDialog({ open: true, isDeposit: true }))}
                      >
                        <Stack
                          direction="row"
                          spacing={'5px'}
                          sx={{
                            p: '5px',
                            alignItems: 'center',
                            display: 'flex',
                          }}
                        >
                          <Iconify
                            icon="mdi:bangladeshi-taka"
                            sx={{
                              width: '20px',
                              height: '20px',
                              borderRadius: '50%',
                              border: '1.5px solid #fff',
                              padding: '2px',
                            }}
                          />
                          <Typography
                            onClick={() =>
                              // dispatch(
                              //   openTransactionsDialog({
                              //     open: true,
                              //     isDeposit: true,
                              //   })
                              // )
                              navigate('/user/wallet')
                            }
                            sx={{
                              // fontSize: '0.25rem',
                              cursor: 'pointer',
                              color: palette.header.balance_button.color,
                            }}
                          >
                            {`${memberBalance?.displayBalance ? fNumber(memberBalance?.displayBalance) : '0'}`}
                          </Typography>
                        </Stack>
                        <ThemeButton sx={{ minWidth: 'unset', display: { sm: 'unset', xs: 'none' } }}>
                          <Stack direction={'row'} spacing={1}>
                            <Iconify icon={'game-icons:wallet'} width={20} height={20} sx={{ color: 'white' }} />
                            <Typography
                              sx={{
                                color: palette.header.deposit_btn.color,
                                // display: { sm: 'unset', xs: 'none' },
                                // fontSize: '0.3rem',
                              }}
                            >
                              {translate('deposit')}
                            </Typography>
                          </Stack>
                        </ThemeButton>
                      </Box>
                    )}
                    {/* <button
              style={{
                backgroundColor: '#ff3141',
                border: 'none',
                padding: '3px 10px',
                borderRadius: '10px',
                cursor: 'pointer',
              }}
              onClick={() =>
                dispatch(
                  openTransactionsDialog({
                    open: true,
                    isDeposit: true,
                  })
                )
              }
            >
              <Iconify icon={'fluent:wallet-24-filled'} width={20} height={20} sx={{ color: 'white' }} />
            </button> */}

                    {isDesktop && (
                      <>
                        <NotificationPopover />

                        <AccountPopover />
                      </>
                    )}
                  </Stack>
                ) : (
                  ''
                )}
              </Stack>
            </Box>
          </Box>

          <LoginSignupDialog setOpenForgotPasswordDialog={setOpenForgotPasswordDialog} />

          <ForgotPasswordDialog
            openForgotPasswordDialog={openForgotPasswordDialog}
            setOpenForgotPasswordDialog={setOpenForgotPasswordDialog}
          />

          <ResetPasswordDialog />
        </Toolbar>
      </RootStyle>
      {isDesktop && (
        <Box sx={{ position: 'fixed', top: `${HEADER.MOBILE_HEIGHT}px`, zIndex: 3, width: '100%' }}>
          <SubHeaderNav />
        </Box>
      )}
    </>
  );
}
